import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Orchid Pro edits Invite for A Series
 */

export default async function modifyAppointmentSeries(
  appointmentSeriesId: string,
  arg: ModifyAppointmentSeriesInput,
): Promise<{
  appointment_series: AppointmentSeriesMetaData;
  invites_created: AppointmentWithSeriesInfo[];
}> {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/appointment/series/modify/${appointmentSeriesId}`,
    {
      body: JSON.stringify(arg),
      method: "PUT",
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return res.json();
}
